/* SAINE · Parallaxe douce sur les grandes photos paysage ([data-rx-px]). */
(function(){
  if(window.__rxpx) return; window.__rxpx=true;
  if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var els=[], ticking=false;
  function collect(){ els=[].slice.call(document.querySelectorAll('.rxb-img, .rxs-img img')); els.forEach(function(el){ el.classList.add('rx-px'); }); update(); }
  function update(){
    ticking=false; var vh=window.innerHeight;
    els.forEach(function(el){
      var box=el.parentElement.getBoundingClientRect();
      if(box.bottom<-100||box.top>vh+100) return;
      var p=((box.top+box.height/2)-vh/2)/(vh/2+box.height/2);
      el.style.transform='translate3d(0,'+(p*-8).toFixed(2)+'%,0) scale(1.18)';
    });
  }
  function onScroll(){ if(!ticking){ ticking=true; requestAnimationFrame(update); } }
  window.addEventListener('scroll',onScroll,{passive:true}); window.addEventListener('resize',onScroll);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',collect); else collect();
  document.addEventListener('shopify:section:load',collect);
})();

/* SAINE · Menu : page en cours ; collections : tri sur la ligne des onglets ;
   titres de section : une partie grasse, une partie fine, taille commune. */
(function(){
  if(window.__rxv32) return; window.__rxv32=true;
  var STOP=/^(en|avec|pour|dès|de|du|des|à|au|aux|nos|vos|sur|sans|qui|dans|et|ou|par|comme|chez|entre|sous|pour|face|selon)$/i;

  function markMenu(){
    var path=location.pathname.replace(/\/$/,'')||'/';
    document.querySelectorAll('.header__menu a.menu__item').forEach(function(a){
      var p=(a.pathname||'').replace(/\/$/,'')||'/';
      var hit=p===path||(p!=='/'&&path.indexOf(p+'/')===0);
      a.classList.toggle('rx-current',hit);
    });
  }

  function moveSort(){
    var tools=document.querySelector('.rxcn-tools'), sort=document.querySelector('.saine-cat-bar .saine-sort');
    if(!tools||!sort) return;
    tools.appendChild(sort);
    var bar=document.querySelector('.saine-cat-bar'); if(bar) bar.classList.add('rx-moved');
  }

  function cut(words){
    var n=words.length, mid=n/2, best=-1, bd=99, i;
    for(i=1;i<n;i++){ if(/[.,:;!?]$/.test(words[i-1])&&i>=n*.25&&i<=n*.75){ var d=Math.abs(i-mid); if(d<bd){bd=d;best=i;} } }
    if(best>0) return best;
    for(i=1;i<n;i++){ if(STOP.test(words[i])&&i>=n*.3&&i<=n*.8){ var e=Math.abs(i-mid); if(e<bd){bd=e;best=i;} } }
    return best>0?best:Math.ceil(n/2);
  }

  function splitHeading(h){
    if(h.dataset.rxSplit) return; h.dataset.rxSplit='1';
    if(h.closest('.product-card,.rx-card,.jdgm-widget,.highlight-text,header,footer,.rxh,.sph-buy,.rxpm')) return;
    if((h.classList.contains('sph-title')&&h.closest('.sph:has(.sph-grid2)'))||h.querySelector('.rx-b,.rx-l,.rx-ab,img,svg,picture,a,input')) return;
    var cs=getComputedStyle(h), fs=parseFloat(cs.fontSize);
    if(h.tagName!=='H1'&&fs>=26&&h.offsetParent!==null&&!h.closest('dialog,.drawer,.modal,[role=dialog]')) h.classList.add('rx-hh');
    if(fs<20) return;
    var txt=(h.textContent||'').replace(/\s+/g,' ').trim();
    var raw=txt.split(' '), words=[];
    raw.forEach(function(w){ if(/^[?!:;»]$/.test(w)&&words.length) words[words.length-1]+=' '+w; else if(w==='«'&&raw.length) words.push(w); else words.push(w); });
    words=words.reduce(function(a,w){ if(a.length&&a[a.length-1]==='«'){a[a.length-1]+=' '+w;} else a.push(w); return a; },[]);
    if(words.length<3) return;
    var k=cut(words);
    var b=document.createElement('span'); b.className='rx-ab'; b.textContent=words.slice(0,k).join(' ');
    var l=document.createElement('span'); l.className='rx-al'; l.textContent=words.slice(k).join(' ');
    h.textContent=''; h.appendChild(b); h.appendChild(document.createTextNode(' ')); h.appendChild(l);
  }

  function headings(){
    document.querySelectorAll('main h1, main h2, main h3').forEach(splitHeading);
  }

  /* fond du site : les sections pleine largeur restées en blanc pur prennent le gris très clair */
  function greyBg(){
    document.querySelectorAll('main .shopify-section > *, main .shopify-section > * > .section').forEach(function(el){
      if(el.offsetWidth<window.innerWidth*0.9) return;
      if(getComputedStyle(el).backgroundColor==='rgb(255, 255, 255)') el.style.setProperty('background-color','var(--rx-bg)','important');
      if(getComputedStyle(el,'::before').backgroundColor==='rgb(255, 255, 255)') el.classList.add('rx-bgfix');
    });
  }

  /* onglets de collection : seule la ligne d'onglets reste collée sous l'en-tête */
  function stickTabs(){
    var cn=document.querySelector('.rxcn'), row=cn&&cn.querySelector('.rxcn-row');
    if(!cn||!row) return;
    var off=row.getBoundingClientRect().top-cn.getBoundingClientRect().top-8;
    cn.style.setProperty('--rxcn-off',Math.max(0,off)+'px');
  }

  function run(){ markMenu(); moveSort(); headings(); greyBg(); stickTabs(); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',run); else run();
  window.addEventListener('load',function(){ headings(); stickTabs(); });
  window.addEventListener('resize',stickTabs);
  document.addEventListener('shopify:section:load',run);
})();
